<template>
<svg class="custom-icon" width="44" height="35" viewBox="0 0 44 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="35" fill="white" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.3157 33.2349C4.91441 33.7137 5.67377 34 6.5 34H37.5C38.3114 34 39.0582 33.7239 39.6518 33.2606L32 27L11.9361 27L4.3157 33.2349ZM13.1584 26H30.7778L21.9681 18.7921L13.1584 26ZM20.3889 17.5L10 26C8.34315 26 7 24.6569 7 23V6.54545L20.3889 17.5ZM23.5473 17.5L33.9361 26H34C35.6569 26 37 24.6569 37 23V6.49321L23.5473 17.5ZM36.9987 3.91017L21.9681 16.2079L7.00024 3.96153C7.02084 2.32241 8.35599 1 10 1H34C35.6268 1 36.9512 2.29487 36.9987 3.91017ZM38.0191 5.65938L41.2695 3H42C42.5523 3 43 3.44772 43 4V23.5C43 24.8807 41.8807 26 40.5 26C39.1193 26 38 24.8807 38 23.5V6C38 5.88483 38.0065 5.77118 38.0191 5.65938ZM8.77778 27L3.17195 31.5866C3.06034 31.2445 3 30.8793 3 30.5C3 28.567 4.567 27 6.5 27H8.77778ZM41 30.5C41 30.8945 40.9347 31.2738 40.8144 31.6276L35.1584 27H37.5C39.433 27 41 28.567 41 30.5ZM5.98678 5.71645L2.66667 3H2C1.44772 3 1 3.44772 1 4V23.5C1 24.8807 2.11929 26 3.5 26C4.88071 26 6 24.8807 6 23.5V6C6 5.90437 5.99553 5.80979 5.98678 5.71645Z" fill="red" />
    </svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
